module.exports = __webpack_public_path__ + "img/image_opt.55e82a1b.jpg";